<template>
  <section>
    <h2 class="sponsors-component section-heading sz-red--text f-24 font-weight-medium text-center">
      {{ $t('home.sponsors') }}
    </h2>

    <div class="sponsors-component__list">
      <div
        v-for="(sponsor, index) in sponsorsList"
        :key="index"
        class="sponsors-component__sponsor"
      >
        <img :src="sponsor.imageUrl" :alt="sponsor.alt" height="85" />
        <v-divider
          class="sponsors-component__divider d-none d-sm-inline-flex"
          vertical
          opacity="1"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Sponsor } from '@/types'
import BNP_ParibasLogo from '@/assets/images/sponsors/BNP_Paribas_logo.png?format=webp'
import TMbileLogo from '@/assets/images/sponsors/timo.png?format=webp'

const sponsorsList: Sponsor[] = [
  { alt: 'BNP Paribas', imageUrl: BNP_ParibasLogo },
  { alt: 'T-Mobile', imageUrl: TMbileLogo }
]
</script>
<style lang="scss">
.sponsors-component {
  &__list {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    gap: 32px;
  }

  &__sponsor {
    height: 85px;

    &:last-child {
      .sponsors-component__divider {
        display: none !important; // override vuetify
      }
    }
  }

  /* stylelint-disable-next-line no-descending-specificity */
  &__divider {
    width: 2px;
    height: 85px;
    margin: 0 16px;
    color: #d3d3d3;
  }
}
</style>
